import { Bar, BarChart, CartesianGrid, Legend, XAxis, YAxis } from 'recharts';
import { type CustomerAnalyticsMoodysReportDto } from '@zg-rentals/ts-customer-analytics-client';
import { Label } from 'recharts';
import { renderChartToPdf, sortReportByQuarter } from './pdfImageUtils';

interface PerformanceChartProps {
  report: CustomerAnalyticsMoodysReportDto;
}

const PerformanceChart = ({ report }: PerformanceChartProps) => {
  if (!report.inventoryReport) return null;
  const hasEffectiveRent = report.performanceReport.some((performanceReport) => performanceReport.effectiveRentPerUnit);
  const data = report.performanceReport
    .filter((row) => row.quarter !== 'Y')
    .sort((a, b) => sortReportByQuarter(a.year, b.year, a.quarter, b.quarter))
    .map((item) => ({
      name: item.quarter === 'Y' ? item.year : `${item.quarter} ${item.year}`,
      askingRent: item.askingRentPerUnit,
      effectiveRent: item.effectiveRentPerUnit,
    }));

  return (
    <BarChart
      width={1400}
      height={500}
      data={data}
      margin={{
        top: 10,
        right: 5,
        left: 20,
        bottom: 30,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis>
        <Label
          value="Rent per unit ($)"
          offset={-8}
          angle={-90}
          position="insideLeft"
          style={{ textAnchor: 'middle', fontSize: '30px' }}
        />
      </YAxis>
      <Legend wrapperStyle={{ position: 'relative', fontSize: '30px', marginTop: '-15px', fontFamily: 'sans-serif' }} />
      <Bar barSize={20} isAnimationActive={false} dataKey="askingRent" fill="#001851" name="Asking Rent" />
      {hasEffectiveRent && (
        <Bar barSize={20} isAnimationActive={false} dataKey="effectiveRent" fill="#b7b7b7" name="Effective Rent" />
      )}
    </BarChart>
  );
};

export const renderPerformanceChart = async (report: CustomerAnalyticsMoodysReportDto): Promise<string> => {
  return await renderChartToPdf(<PerformanceChart report={report} />);
};
